const MenuItems = {
    startNow: { id: 'start-now', name: 'Start now' },
    whoWeAre: { id: 'who-we-are', name: 'Our Goal' },
    experiences: { id: 'experiences', name: "What's AR?" },
    // ourLads: { id: 'our-lads', name: 'Our Lads' },
    ourApp: { id: 'our-app', name: 'Our App' },
    benefits: { id: 'benefits', name: 'Benefits' },
    // retail: { id: 'retail', name: 'Become Retailer' },
};

export default MenuItems;
